import axiosInstance from '../../axios/axiosInstance';
import apiEndpoints from '../../axios/api';
import { fetchAssignableRoles } from '../../components/MemberRoleSelect';

// Edit forms need to preselect the entity's current role, but the occupant /
// vendor detail responses don't embed the user-society row.
//
// Members (OWNERSHIP / OCCUPANCY rows) ask /occupants/assignable-roles, which
// returns the role on that row to anyone who may edit members. Vendors still
// scan the user-societies listing by source_type + source_row_id (that needs
// user.read and only looks at the first 100 users).
//
// Returns the role_id for the matching row, or null if no match / on error.
const MEMBER_SOURCES = ['OWNERSHIP', 'OCCUPANCY'];

export const fetchCurrentRoleId = async ({ societyId, sourceType, sourceRowId }) => {
    if (!sourceType || sourceRowId == null) return null;
    if (MEMBER_SOURCES.includes(sourceType)) {
        const data = await fetchAssignableRoles({ source_type: sourceType, source_row_id: sourceRowId });
        return data?.current_role_id || null;
    }
    if (!societyId) return null;
    try {
        const url = apiEndpoints.GET_SOCIETY_USERS_API.replace(':societyId', societyId);
        const res = await axiosInstance.get(url, { params: { page: 1, limit: 100 } });
        const rows = res?.data?.rows || res?.data || [];
        const match = rows.find(
            (row) =>
                row.source_type === sourceType &&
                String(row.source_row_id) === String(sourceRowId),
        );
        return match?.role?.role_id || match?.role_id || null;
    } catch (e) {
        return null;
    }
};

export default fetchCurrentRoleId;
